import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { InventoryTradingDaysTable } from '../../../../../../../../../../features/inventory/trading-day/inventory-trading-days-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsInventory,
      label: 'Trading Day',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsInventory>,
  head: () => getPageHead('Inventory Trading Days'),
  component: InventoryTradingDayList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsInventory}
    />
  );
}

function InventoryTradingDayList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <InventoryTradingDaysTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
